import _slicedToArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isNativeAudioNode } from '../guards/native-audio-node';
export var wrapAudioNodeDisconnectMethod = function wrapAudioNodeDisconnectMethod(nativeAudioNode) {
  var connections = new Map();

  nativeAudioNode.connect = function (connect) {
    return function (destination) {
      var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var returnValue = isNativeAudioNode(destination) ? connect(destination, output, input) : connect(destination, output); // Save the new connection only if the calls to connect above didn't throw an error.

      var connectionsToDestination = connections.get(destination);

      if (connectionsToDestination === undefined) {
        connections.set(destination, [{
          input: input,
          output: output
        }]);
      } else {
        if (connectionsToDestination.every(function (connection) {
          return connection.input !== input || connection.output !== output;
        })) {
          connectionsToDestination.push({
            input: input,
            output: output
          });
        }
      }

      return returnValue;
    };
  }(nativeAudioNode.connect.bind(nativeAudioNode));

  nativeAudioNode.disconnect = function (disconnect) {
    return function (destinationOrOutput, output, input) {
      disconnect.apply(nativeAudioNode);

      if (destinationOrOutput === undefined) {
        connections.clear();
      } else if (typeof destinationOrOutput === 'number') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = connections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var destination = _ref2[0];
            var connectionsToDestination = _ref2[1];
            var filteredConnections = connectionsToDestination.filter(function (connection) {
              return connection.output !== destinationOrOutput;
            });

            if (filteredConnections.length === 0) {
              connections.delete(destination);
            } else {
              connections.set(destination, filteredConnections);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (connections.has(destinationOrOutput)) {
        if (output === undefined) {
          connections.delete(destinationOrOutput);
        } else {
          var _connectionsToDestination = connections.get(destinationOrOutput);

          if (_connectionsToDestination !== undefined) {
            var _filteredConnections = _connectionsToDestination.filter(function (connection) {
              return connection.output !== output && (connection.input !== input || input === undefined);
            });

            if (_filteredConnections.length === 0) {
              connections.delete(destinationOrOutput);
            } else {
              connections.set(destinationOrOutput, _filteredConnections);
            }
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var _ref4 = _step2.value;
          _ref5 = _slicedToArray(_ref4, 2);
          var destination = _ref5[0];
          var connectionsToDestination = _ref5[1];
          connectionsToDestination.forEach(function (connection) {
            if (isNativeAudioNode(destination)) {
              nativeAudioNode.connect(destination, connection.output, connection.input);
            } else {
              nativeAudioNode.connect(destination, connection.output);
            }
          });
        };

        for (var _iterator2 = connections[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref5;

          _loop();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    };
  }(nativeAudioNode.disconnect);
};